import React from 'react';

import { TextField } from '@mui/material';

interface Props {
  subdued?: boolean;
  value: string;
}

export default function ReadOnlyField({ subdued, value }: Props) {
  return (
    <TextField
      fullWidth
      size="small"
      value={value}
      InputProps={{ readOnly: true }}
      inputProps={{ 'aria-readonly': true }}
      sx={{
        minWidth: 130,
        '& .MuiInputBase-input': {
          color: subdued ? 'text.secondary' : 'text.primary',
          fontSize: 13,
          fontWeight: subdued ? 400 : 500,
          py: 0.75,
        },
        '& .MuiOutlinedInput-root': {
          bgcolor: 'background.paper',
        },
      }}
    />
  );
}
